<script setup lang="ts">
import { createMetaInfoObject } from '~/lib'
const route = useRoute()
const router = useRouter()

const { t } = useI18n()

useSeoMeta(
  createMetaInfoObject([
    ['title', `${t('seo.pageTitles.search')} | Careum`],
    ['robots', 'noindex, nofollow'],
  ]),
)

const {
  search,
  getElements: products,
  getTotalPagesCount,
  getCurrentPage,
  changeCurrentPage,
  loading,
  setInitialListing,
  getCurrentListing,
  getTotal,
} = useListing({
  listingType: 'productSearchListing',
  defaultSearchCriteria: {
    search: '', // Provide empty search by default
    order: 'is-set',
    associations: {
      seoUrls: {},
    },
  },
})

const { data: productSearch } = await useAsyncData(
  'productSearch',
  async () => {
    await search({
      search: (route.query.search as string) || '', // Ensure search is always a string
      ...route.query,
      limit: 12,
    })
    return getCurrentListing.value
  },
  {
    watch: [route],
  },
)
const changePage = async (page: number) => {
  await router.push({
    query: {
      ...route.query,
      limit: 12,
      p: page,
    },
  })
  changeCurrentPage(page, {
    search: (route.query.search as string) || '',
    ...route.query,
  })
}
if (productSearch.value) {
  setInitialListing(productSearch.value)
}
</script>
<template>
  <Hero class="section-hero" :content="{ title: t('shop.searchPage.title') }" />
  <Section>
    <ShopSearch class="t-10 t-o-1 tl-o-0 ds-o-1 ds-8" />
  </Section>
  <Section>
    <div class="tl-11 tl-o-1">
      <h2>{{ getTotal }} {{ t('shop.searchPage.searchResultsFor') }} "{{ route.query.search }}"</h2>
      <div v-if="loading">
        {{ t('shop.searchPage.loading') }}
      </div>
      <Products v-if="products.length" :products="products" />
      <p v-else>
        {{ t('shop.searchPage.noResults') }}
      </p>
      <Pagination
        v-if="getTotalPagesCount > 1"
        :page="Number(getCurrentPage)"
        :max="getTotalPagesCount"
        @update:page="changePage"
      />
    </div>
  </Section>
</template>
<style scoped lang="scss">
.products {
  margin-bottom: 64px;
}
:deep(.pagination) {
  margin-bottom: 50px;
  @include breakpoint(t) {
    margin-bottom: 250px;
  }
}
</style>
